import React, {Fragment, useState} from "react";
import {Col, FormGroup, Label, Row} from "reactstrap";
import Select from "react-select";


const BuyerLeadAddressForm = (props) => {
    const {
        errors,
        control,
        register,
        setValue,
        trigger,
        getValues,
        searchSellersByName,
        sellers,
        setOptions,
        promiseOptions,
        showHs=false,
        formText,
        countries
    } = props;
    const country = getValues('country')?getValues('country'): '';
    const [dialCode, setDialCode] = useState(country.dial_code);

    return (
        <Fragment>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label className="col-form-label">First Name</Label>
                        <input name="first_name" type="text" {...register('first_name')} className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.first_name?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="col-form-label">Last Name</Label>
                        <input name="last_name" type="text" {...register('last_name')} className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.last_name?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="col-form-label">Company Name</Label>
                        <input name="company" type="text" {...register('company')} className={`form-control ${errors.company ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.company?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="col-form-label">Address Line 1</Label>
                        <input name="address_1" type="text" {...register('address_1')} className={`form-control ${errors.address_1 ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.address_1?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="col-form-label">Address Line 2</Label>
                        <input name="address_2" type="text" {...register('address_2')} className={`form-control ${errors.address_2 ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.address_2?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label className="col-form-label">City</Label>
                        <input name="city" type="text" {...register('city')} className={`form-control ${errors.city ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.city?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup className="mt-2">
                        <Label className="form-label">Country</Label>
                        <Select placeholder="Country Name" name="country" getOptionLabel={(option) => option.name}
                                value={getValues('country')}
                                getOptionValue={(option) => option.id} {...register("country")}
                                onChange={(e) => {
                                    setValue('country', e);
                                    setDialCode(e.dial_code)
                                    trigger('country');
                                }} className={` ${errors.country ? 'is-invalid' : ''}`}
                                options={countries}/>
                        <div className="invalid-feedback">{errors.country?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label className="col-form-label">Province</Label>
                        <input name="province" type="text" {...register('province')} className={`form-control ${errors.province ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.province?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label className="col-form-label">Postal code / Zip</Label>
                        <input name="zip" type="text" {...register('zip')} className={`form-control ${errors.zip ? 'is-invalid' : ''}`}/>
                        <div className="invalid-feedback">{errors.zip?.message}</div>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    {/*<FormGroup>*/}
                    {/*    <Label className="col-form-label">Phone Number</Label>*/}
                    {/*    <input name="first_name" type="text" {...register('phone_number')} className={`form-control ${errors.phone_number ? 'is-invalid' : ''}`}/>*/}
                    {/*    <div className="invalid-feedback">{errors.phone_number?.message}</div>*/}
                    {/*</FormGroup>*/}
                    <Label className="form-label">Phone Number</Label>
                    <FormGroup className="input-group">
                        <span className="input-group-text">{dialCode}</span>
                        <input name="phone_number" type="text"
                               className={`form-control ${errors.phone_number ? 'is-invalid' : ''}`}
                               placeholder="Phone Number" {...register('phone_number')}  />
                        <div className="invalid-feedback">{errors.phone_number?.message}</div>
                    </FormGroup>
                </Col>
            </Row>
        </Fragment>
    );

}

export default BuyerLeadAddressForm;